import React, { createContext, PropsWithChildren } from "react";
import { Bounds } from "viewport-mercator-project";
import { Point } from "../LayeredMap/types";

export type MapZoomContextType = {
  zoomToPoint: (point: Point, zoom?: number) => Promise<void>;
  zoomToBounds: (bounds: Bounds, infoPanelVisible?: boolean) => Promise<void>;
};

const noop = async () => {};

export const MapZoomContext = createContext<MapZoomContextType>({
  zoomToPoint: noop,
  zoomToBounds: noop,
});

export const MapZoomProvider = ({
  zoomToPoint,
  zoomToBounds,
  children,
}: PropsWithChildren<MapZoomContextType>) => {
  return (
    <MapZoomContext.Provider value={{ zoomToPoint, zoomToBounds }}>
      {children}
    </MapZoomContext.Provider>
  );
};
